const $_documentContainer = document.createElement('template');

$_documentContainer.innerHTML = `
<dom-module id="nimbus-styles">
  <template>
    <style>
      .ndsgn-auth-form,
      .ndsgn-auth-form * {
        box-sizing:border-box;
        -webkit-box-sizing:border-box;
        -moz-box-sizing:border-box;
        font-family:'Noto Sans', Verdana,Arial,sans-serif;
      }

      .ndsgn-auth-form {
        max-width:444px !important;
        margin: 0 auto;
        text-align:center;
        font-size:12px;
        width: 100%;
      }
      .ndsgn-auth-form-content {
        position: relative;
        color: rgba(0,0,0, 0.60);
      }
      .ndsgn-auth-form-close {
        padding: 0 0 8px 0;
      }
      .ndsgn-auth-form-inner {
        min-height: 300px;
        margin: 0 auto;
      }

      .ndsgn-auth-form-notes-text a {
        color:#0096a5;
        text-decoration:none;
        outline:none;
        cursor:pointer;
      }
      .ndsgn-auth-form-notes-text a:hover {
        color:#148599;
      }

      .ndsgn-auth-form-top-icon,
      .ndsgn-auth-form-top-text,
      .ndsgn-auth-form-notes-text,
      .ndsgn-auth-form-submit {
        padding:8px 0;
      }

      .ndsgn-auth-switch,
      .ndsgn-auth-or,
      .ndsgn-auth-form-restored,
      .ndsgn-auth-form-permission {
        padding:8px 0;
      }
      .ndsgn-auth-form-other-methods-button,
      .ndsgn-auth-form-actions-switch-button {
        padding: 8px 0;
      }

      .ndsgn-auth-form-other-methods[layout="row"] {
        padding: 4px;
      }
      .ndsgn-auth-form-other-methods[layout="row"] .ndsgn-auth-form-other-methods-button {
        padding: 4px 8px;
      }

      .ndsgn-auth-form-or-line {
        background:#DCDCDC;
        height:1px;
      }
      .ndsgn-auth-form-or-text {
        padding:0 4px;
        font-size: 14px;
      }

      .ndsgn-auth-form-top-text {
        font-size: 14px;
        color: rgba(0,0,0, 0.8);
      }

      .ndsgn-auth-form-restored {
        font-size: 14px;
        color: rgba(0,0,0, 0.8);
      }

      .ndsgn-auth-form-permission-top-holder {
        display:inline-block;
        text-align:left;
      }
      .ndsgn-auth-form-permission-top-title {
        padding:0 0 16px 0;
        font-size: 21px;
        color: #1D1D1D;
        text-align: center;
      }
      .ndsgn-auth-form-permission-top ul li {
        display:block;
        list-style:none;
        position:relative;
        padding:2px 0 2px 20px;
        min-height:1px;
        font-size: 14px;
        color: rgba(0,0,0, 0.8);
      }
      .ndsgn-auth-form-permission-top ul li:before {
        content:"";
        display:block;
        position:absolute;
        left:0;
        top:6px;
        width:10px;
        height:10px;
        border-radius:50%;
        background:#0096a5;
      }
      .ndsgn-auth-form-permission-text {
        padding: 24px 0 0 0;
        font-size: 12px;
      }

      @media only screen and (max-width: 480px) {
        .ndsgn-auth-form-form {
          width:100%;
        }
      }

      /*input*/
      .ndsgn-input {padding:12px 0; position: relative;}
      .ndsgn-input-label {display:block; padding:0 0 8px 0;}
      .ndsgn-input input {
        display:block;
        width:100%;
        padding:0 16px;
        height:40px;
        border:1px solid #cfd1d3;
        border-radius:2px;
        box-sizing:border-box;
        -webkit-appearance:none;
        font-size: 14px;

        transition:all 0.1s ease-out;
        -webkit-transition:all 0.1s ease-out;
      }
      .ndsgn-input input:hover {border-color:#bbb;}
      .ndsgn-input input:focus {border-bottom-color:#19a1b9;}
      .ndsgn-input-error-text {
        font-size:12px;
        display:none;
        color:#FA5750;
        padding: 0 16px;
        text-align: left;
        line-height: 1.2;
        margin: 4px 0 -12px 0;
      }

      .ndsgn-input-invalid .ndsgn-input-label {color:rgb(244, 67, 54);}
      .ndsgn-input-invalid input {border-bottom-color:rgb(244, 67, 54);}
      .ndsgn-input-invalid .ndsgn-input-error-text {display:block;}

      .ndsgn-input input[readonly] {background:#EBEFF1;}

      /*button*/
      .ndsgn-button {
        display:inline-block;
        vertical-align:top;
        position:relative;
        background:#009FB7;
        text-align:center;
        border:1px solid #009FB7;
        color:#fff;
        cursor:pointer;
        padding:10px 16px;
        border-radius:2px;
        font-size:14px;
        box-sizing:border-box;
        text-decoration:none;
        line-height: 18px;

        transition:all 0.1s ease-out;
        -webkit-transition:all 0.1s ease-out;
      }
      .ndsgn-button:hover,
      .ndsgn-button:focus {background:#148599; border-color: #148599;}

      .ndsgn-button[disabled] {background:rgba(0,0,0, 0.2); border-color: rgba(0,0,0, 0.2); cursor:auto;}
      .ndsgn-button[disabled]:hover,
      .ndsgn-button[disabled]:focus {background:rgba(0,0,0, 0.2); border-color: rgba(0,0,0, 0.2);}

      .ndsgn-button.ndsgn-button-text-colored {color:#0095A7; background:none; border:1px solid transparent;}
      .ndsgn-button.ndsgn-button-text-colored:hover,
      .ndsgn-button.ndsgn-button-text-colored:focus {background:rgba(0, 149, 167, 0.1); border-color:rgba(0, 149, 167, 0.1);}

      .ndsgn-button.ndsgn-button-full-width {width:100%; display:block;}

      .ndsgn-button.ndsgn-button-cleared {
        background: none;
        border: none;
        padding: 0;
      }
      .ndsgn-button.ndsgn-button-cleared:hover,
      .ndsgn-button.ndsgn-button-cleared:focus {
        background: none;
        border: none;
      }

      .ndsgn-button-google-button,
      .ndsgn-button-google-button:hover,
      .ndsgn-button-google-button:focus {
        background:#fff;
        border-color: rgba(0,0,0,0.12);
        color: rgba(0,0,0,0.60);
      }
      .ndsgn-button-google-button:hover,
      .ndsgn-button-google-button:focus {
        background: #F8F8F8;
      }
      .ndsgn-button-facebook-button,
      .ndsgn-button-facebook-button:hover,
      .ndsgn-button-facebook-button:focus {
        background:#3c5a96;
        border-color:#3c5a96;
      }
      .ndsgn-button-facebook-button:hover,
      .ndsgn-button-facebook-button:focus {
        background: #4064A6;
      }

      .ndsgn-button-google-button .ndsgn-button-layout,
      .ndsgn-button-facebook-button .ndsgn-button-layout {
        min-width: 28px;
      }

      .ndsgn-auth-form-submit .ndsgn-button {
        padding-left: 24px;
        padding-right: 24px;
      }

      /*query*/
      @media only screen and (max-width: 480px) {
        .ndsgn-auth-form-inner {
          max-width: 320px;
          margin: 0 auto;
        }
      }
      @media only screen and (max-width: 320px) {
        .ndsgn-auth-form-inner {
          width: 100%;
        }
      }
      :host(.nns-theme-night) .ndsgn-auth-form-content {
        background: #414b4c;
        border-color: #2f3737;
        color: rgba(255,255,255, 0.6);
      }

      :host(.nns-theme-night) .ndsgn-auth-form-or-line {
        background: #9ea5a6;
      }
      :host(.nns-theme-night) .ndsgn-input inputt {
        background: #3C4849;
        border-color:#2F3737;
        color:#fff;
      }
      :host(.nns-theme-night) .ndsgn-input-invalid input {border-bottom-color:rgb(244, 67, 54);}
      :host(.nns-theme-night) .ndsgn-input input:hover,
      :host(.nns-theme-night) .ndsgn-input input:focus {
        border-color:#2F3737;
        background:rgba(181,181,181,0.10);
      }
      :host(.nns-theme-night) .ndsgn-input input input[readonly] {
        background:rgba(0,0,0,0.12);
      }

      :host(.nns-theme-night) .ndsgn-auth-form-top-text,
      :host(.nns-theme-night) .ndsgn-auth-form-restored,
      :host(.nns-theme-night) .ndsgn-auth-form-permission-top ul li {
        color: rgba(255,255,255, 0.8);
      }

      :host(.nns-theme-night) .ndsgn-auth-form-permission-top-title{
        color: #fff;
      }
    </style>
  </template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
